/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S3_TitleInputs */

const en_guide_what_is_json_s3_title = /** @type {(inputs: Guide_What_Is_Json_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why JSON Became the Standard`)
};

const ko_guide_what_is_json_s3_title = /** @type {(inputs: Guide_What_Is_Json_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON이 표준이 된 이유`)
};

const ja_guide_what_is_json_s3_title = /** @type {(inputs: Guide_What_Is_Json_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONが標準になった理由`)
};

/**
* | output |
* | --- |
* | "Why JSON Became the Standard" |
*
* @param {Guide_What_Is_Json_S3_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s3_title = /** @type {((inputs?: Guide_What_Is_Json_S3_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S3_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s3_title(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s3_title(inputs)
	return ja_guide_what_is_json_s3_title(inputs)
});